import React from "react";
import Container from "./styles";

const DefaultContainer: React.FC = ({children}) => <Container>{children}</Container>;

export default DefaultContainer;
